import React, { Component } from "react";
import {Link} from "react-router-dom";

const PortfolioListContent = [
    {
      image: 'https://images.pexels.com/photos/6956451/pexels-photo-6956451.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      category: 'Campaña Digital',
      title: 'Estrategia de lanzamiento para una nueva línea de productos'
    },
    {
      image: 'https://images.pexels.com/photos/389734/pexels-photo-389734.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      category: 'Redes Sociales',
      title: 'Aumento de engagement en Instagram para una marca de moda'
    },
    {
      image: 'https://images.pexels.com/photos/40185/mac-freelancer-macintosh-macbook-40185.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
      category: 'Posicionamiento SEO',
      title: 'Optimización de contenidos para incrementar tráfico web'
    },
    // {
    //   image: 'image-4',
    //   category: 'Branding',
    //   title: 'Rebranding completo para una empresa tecnológica'
    // },
    // {
    //   image: 'image-5',
    //   category: 'Publicidad',
    //   title: 'Creación de anuncios para una campaña en Google Ads'
    // },
    // {
    //   image: 'image-6',
    //   category: 'Email Marketing',
    //   title: 'Desarrollo de newsletters para fidelización de clientes'
    // }
  ];
  

class PortfolioList extends Component{
    render(){
        const {column , styevariation } = this.props;
        const list = PortfolioListContent.slice(0 , this.props.item);
        return(
            <React.Fragment> 
                {list.map((value , index) => (
                    <div className={`${column}`} key={index}>
                        <div className={`portfolio ${styevariation}`}>
                            <div className="thumbnail-inner">
                                <div className={`thumbnail ${value.image}`} style={{backgroundImage: `url(${value.image})`}}></div>
                                <div className={`bg-blr-image ${value.image}`}></div>
                            </div>
                            <div className="content">
                                <div className="inner">
                                    <p>{value.category}</p>
                                    <h4><a href="/portfolio-details">{value.title}</a></h4>
                                    <div className="portfolio-button">
                                        {/* <a className="rn-btn" href="/portfolio-details">Ver Más</a> */}
                                    </div>
                                </div>
                            </div>
                            {/* <Link className="link-overlay" to="/portfolio-details"></Link> */}
                        </div>
                    </div>
                ))}
               
            </React.Fragment>
        )
    }
}
export default PortfolioList;